import LabeledAutocomplete from "./LabeledAutocomplete";
import { withStyles } from "@material-ui/core/styles";
import styles from "../Autocomplete/styles";

import { compose } from "recompose";

const enhance = compose(withStyles(styles, { withTheme: true }));

export default enhance(LabeledAutocomplete);
